import ClinicDepartmentService from "../../../../../../services/ClinicDepartmentService";
import { LabResultCalcualtion, fetchTimeInterval, getCurrentDate, getCurrentTime, getLookupByKey, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { LAB_TEST_RESULT, VACCINATION_STATUS } from "../../../../../../utils/constant";
import DropDownService from "../../../../../../services/DropDownService";
import { computationRules1 } from "./DrugScreenCollection";

// export const fetchReasonForLabList = async (val, props, callback = () => { }) => {
//   // const {employeeDetails} = props;
//   let optionArr = [];
//   try {
//     const reasonForLabs = await getLookupByKey('reason_for_lab');
//     optionArr = reasonForLabs; 
//     callback(optionArr);
//   } catch (e) {

//   }
//   return optionArr;
// }

export const fetchClinicDepartment = (val, props, callback = () => { }) => {
  //{search_query:val}
  let optionArr = [];
  ClinicDepartmentService.getClinicDepartmentByClinicId(null,props.employeeDetails.clinic_id)
    .then((res) => {
      // console.log("clinicLocationList", res);
      res?.map((clinic, locationIndex) => {
        optionArr.push({
          label: clinic.facility_name,
          value: clinic.id,
          data: clinic,
          index: locationIndex
        });
      });
      callback(optionArr);

    })
    .catch((error) => {
      console.error(error);
    });
  return optionArr;
}


export const fetchLabChoiceList = async (val, props, callback = () => {}) => {
  //{search_query:val}
  let optionArr = [];
  try {
    const query = { clinic_id: props.employeeDetails.clinic_id };
    const res = await DropDownService.getLabsforClinic(null, query);
    if (Array.isArray(res) && res.length > 0) {
      res.forEach((item, itemIndex) => {
        optionArr.push({
          label: item.name,
          value: item.lab_id,
          data: item,
          index: itemIndex
        });
      });
    }
    callback(optionArr);
  } catch (error) {
    console.error('Error fetching lab list:', error);
  }

  return optionArr;
};
export const fetchVaccinationStatus = async (val, props, callback = () => { }) => {
  // const {employeeDetails} = props;
  let optionArr = [];
  try {
    const vaccination_status = await getLookupByKey(VACCINATION_STATUS);
    optionArr = vaccination_status;
    callback(vaccination_status);
  } catch (e) {

  }
  return optionArr;
}
export const fetchTestResult = async (val, props, callback = () => { }) => {
  // const {employeeDetails} = props;
  let optionArr = [];
  try {
    const labTestResult = await getLookupByKey(LAB_TEST_RESULT);
    optionArr = labTestResult;
    callback(labTestResult);
  } catch (e) {

  }
  return optionArr;
}


// export const fetchLabOrderList = (val,props,callback=()=>{})=>{
//   //{search_query:val}
//   const {formData} = props;
//   console.log('formData',formData);
//   let optionArr =[];
//   LabOrderdService.getLabOrder(null,formData?.lab_id) 
//   .then((res) => {
//     res.data?.data?.map((item, itemIndex) => {
//       optionArr.push({
//         label:item.name,
//         value:item.lab_id,
//         data:item,
//         index:itemIndex
//       });
//     });
//     callback(optionArr);

//   })
//   .catch((error) => {
//     console.error(error);
//   });
//   return optionArr;
// }

export const LaboratoryNew = (props) => {

console.log('props',props);
const visitType = props.visitType ? props.visitType : '';

  // Activity Status options based on visitType
  const activityStatusOptions = visitType==='WorkComp'
    ? ['Not Started', 'In Progress', 'Ordered', 'Ready for Review', 'Pending Provider Review', 'Completed', 'Cancelled']
    : ['Not Started', 'In Progress', 'Ordered', 'Pending Provider Review', 'Passed', 'Failed', 'Cancelled'];

  const stackedFieldStyle = {
    layout: 'stacked',
    showContainerBorder: false,
    labelWrap: false,
    isLabel: false,
  };


  let charts = [{
    type: 'Grid',
    col: 'col-md-3',
    data: [{
      type: "PatientDetails",
      employeeDetails: props.employeeDetails,
      visitDetails: props.visitDetails
    }, {
      type: "CompanyDetails",
      companyDetails: props.companyDetails
    }],
  },
  {
    type: 'Tab',
    col: 'col-md-9',
    data: [
      {
        label: 'Lab order',
        id: 'lab_order',
        data: [
          {
            label: "Lab Order Details",
            labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                label: "Lab Choice",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "lab_id",
                id: "lab_id",
                options: [],
                type: 'NewSelectSearchList',
                isAsync: true,
                loadCallBack: (val, callback) => fetchLabChoiceList(val, props, callback),
                required: true,
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                options: [],
                label: "Lab Order",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "lab_order_id",
                type: 'NewSelectSearchList',
                isAsync: true,
                loadCallBack: (val, callback) => props.fetchLabOrderList(val, props, callback),
                required: true,
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewDate",
                label: "Test Date",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "test_date",
                required: true,
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewSelectSearchList",
                label: "Test Time",
                placeholder: "Test Time",
                isAsync: true,
                options: [{ label: getCurrentTime(), value: getCurrentTime() }],
                loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
                className: "form-control form-control-solid",
                name: "test_time",
                required: true,
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
            ]
          },
          {
            label: "Activity Details",
            labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                type: "NewTextInput",
                label: "Accession",
                placeholder: "Accession",
                className: "form-control form-control-solid",
                name: "accession",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewTextInput",
                label: "Sample ID",
                placeholder: "Sample ID",
                className: "form-control form-control-solid",
                name: "sample_id",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewDate",
                label: "Result Date",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "result_date",
                col: "col-lg-3 col-md-3 col-12 border-0",
              },
              {
                type: "NewSelectSearchList",
                label: "Result Time",
                placeholder: "Result Time",
                isAsync: true,
                options: [{ label: getCurrentTime(), value: getCurrentTime() }],
                loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
                className: "form-control form-control-solid",
                name: "result_time",
                col: "col-lg-3 col-md-3 col-12 border-0",
              },
              {
                type: "NewDate",
                label: "Received Date",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "received_date",
                col: "col-lg-3 col-md-3 col-12 border-0",
              },
              {
                type: "NewSelectSearchList",
                label: "Received Time",
                placeholder: "Received Time",
                isAsync: true,
                options: [{ label: getCurrentTime(), value: getCurrentTime() }],
                loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
                className: "form-control form-control-solid",
                name: "received_time",
                col: "col-lg-3 col-md-3 col-12 border-0",
              },
            ]
          },
          {
            label: "Notes",
            labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                type: "NewTextArea",
                label: "Notes",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "notes",
                col: "col-12 border-0",
              },
            ]
          },
        ]
      },
      {
        label: 'Lab Results',
        id: 'lab_result',
        data: [
          {
            label: "Test Name",
            labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              // {
              //   options: [],
              //   label: "Test Result",
              //   placeholder: "",
              //   className: "form-control form-control-solid",
              //   name: "test_result",
              //   type: 'NewSelectSearchList',
              //   isAsync: true,
              //   loadCallBack: (val, callback) => fetchTestResult(val, props, callback),
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              // {
              //   type: "NewTextInput",
              //   label: "Result Value",
              //   placeholder: "Result Value",
              //   className: "form-control form-control-solid",
              //   name: "result_value",
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              // {
              //   type: "NewTextInput",
              //   label: "Units",
              //   placeholder: "Units",
              //   className: "form-control form-control-solid",
              //   name: "units",
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              // {
              //   type: "NewTextInput",
              //   label: "Flag",
              //   placeholder: "Flag",
              //   className: "form-control form-control-solid",
              //   name: "flag",
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              // {
              //   type: "NewTextInput",
              //   label: "Reference Range",
              //   placeholder: "Reference Range",
              //   className: "form-control form-control-solid",
              //   name: "reference_range",
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              // {
              //   type: "NewTextInput",
              //   label: "Test Range",
              //   placeholder: "",
              //   className: "form-control form-control-solid",
              //   name: "test_range",
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              {
                type: 'LabPanel',
                employeeDetails: props.employeeDetails,
                visitDetails: props.visitDetails,
                formData: props.formData,
                fetchLabOrderList: props.fetchLabOrderList,
                fetchRecords: props.fetchPatientChartDetials,
                setChildLab: props.setChildLab,
                childLab: props.childLab,
                updateFormData: props.updateFormData,
                col: "col-12 border-0",
              },
            ]
          },
          {
            label: "Final Result Determination",
            labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                type: "ResultNotesWithSendMessage",
                label: "Notes",
                placeholder: "",
                className: "form-control form-control-solid",
                name: "result_notes",
                resultActionFieldName: "result_action",
                hideSendButton: true,
                resultActionOptions: [
                  { value: "no_action_needed", label: "No Action Needed" },
                  { value: "schedule_booster", label: "Schedule Booster Appointment" },
                  { value: "schedule_asap", label: "Schedule Patient for Appointment ASAP" },
                  { value: "other_action", label: "Other" },
                ],
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              // {
              //   label: "Lab Result",
              //   type: "NewSelectList",
              //   options: [
              //     { label: "PENDING", value: "PENDING" },
              //     { label: "PASSED", value: "PASSED" },
              //     { label: "FAILED", value: "FAILED" },
              //   ],
              //   name: "status",
              //   col: "col-lg-6 col-md-6 col-12 border-0",
              // },
              {
                type: "CheckBoxGroup",
                label: "Actions",
                name: "result_action",
                singleSelect: true,
                singleSelectDefault: "no_action_needed",
                isLabel: false,
                isVertical: true,
                col: "col-12 border-0",
                showContainerBorder: false,
                options: [
                  { value: "no_action_needed", label: "No Action Needed" },
                  { value: "schedule_booster", label: "Schedule Booster Appointment" },
                  { value: "schedule_asap", label: "Schedule Patient for Appointment ASAP" },
                  { value: "other_action", label: "Other" },
                ],
              },
            ],
            footerFields: [
              {
                type: "SendMessageButton",
                name: "result_notes",
                resultActionFieldName: "result_action",
                resultActionOptions: [
                  { value: "no_action_needed", label: "No Action Needed" },
                  { value: "schedule_booster", label: "Schedule Booster Appointment" },
                  { value: "schedule_asap", label: "Schedule Patient for Appointment ASAP" },
                  { value: "other_action", label: "Other" },
                ],
              },
            ],
          },
          // {
          //   label: "Results Reviewed - Authorized Signature",
          //   labelStyle: "fw-semibold",
          //   fieldProps: stackedFieldStyle,
          //   fields: [
          //     {
          //       type: "ProviderSignOff",
          //       col: "col-lg-9 col-md-9 col-12 border-0",
          //       pinFieldName: "signature_pin",
          //       signatureFieldName: "authorized_signature",
          //       authorizedNameFieldName: "provider_name",
          //       signedDateFieldName: "review_date",
          //       authorizedNameLabel: "Provider Name",
          //       signedDateLabel: "Date",
          //       showAuthorizedFieldsAlways: true,
          //       fields: [
          //         { label: "Signature Pin", name: "signature_pin", col: "col-12" },
          //         { label: "Signature", type: "NewSignature", name: "authorized_signature", col: "col-12" },
          //       ],
          //     },
          //     {
          //       label: "Review Status",
          //       type: "NewSelectList",
          //       options: [
          //         { label: "Not Started", value: "Not Started" },
          //         { label: "In Progress", value: "In Progress" },
          //         { label: "Completed", value: "Completed" },
          //       ],
          //       name: "review_status",
          //       col: "col-lg-3 col-md-3 col-12 border-0",
          //     },
          //   ]
          // },
          {
            label: "Review / Completion",
            labelStyle: "fw-semibold",
            fields: [
                {
                    type: "ProviderSignOff",
                    col: "col-12",
                    fields: [
                        { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                        { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                        { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                        // Previous options:
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending Result','Normal', 'Abnormal']),statusBasedColor:true},
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(activityStatusOptions),statusBasedColor:true},
                        // New standard options:
                        { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive'],false),statusBasedColor: true,},
                        { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled'],false),statusBasedColor: true },
                    ],
                },
            ],
        }
        ]
      },
      {
        id: 'Images',
        label: 'Images',
        data: []
      }
    ],
  }];
  const defaultValue = {
    status: 'Not Started',
    suggested_status: 'Not Started',
    review_status: 'Not Started',
    activity_status: 'Not Started',
    result_action: 'no_action_needed',
    test_date: getCurrentDate(),
    test_time: getCurrentTime(),
    result_date: getCurrentDate(),
    result_time: getCurrentTime(),
    received_time: getCurrentTime(),
    // reason:'Pre-employment'
  };
  const buttons = {
    label: false,
    labreport: false,
    showTopUpdateButton: false,
    showLabTopActions: true,
  }
  const headers = [];
  return { buttons, charts, defaultValue, headers,  computationFunction: (formData, key) => computationRulesForLaboratoryNew(formData, key,visitType) };
}

const computationRulesForLaboratoryNew = (formData, key,visitType) => {
  let returnResult = {};
  const childLab = Array.isArray(formData.child_lab) ? formData.child_lab : [];
  const childLabResults = childLab
    .map((item) => String(item?.result || "").toLowerCase())
    .filter(Boolean);
  const hasChildLabResults = childLabResults.length > 0;
  const isResultfailedchildlab =
    hasChildLabResults &&
    childLabResults.some(
      (result) =>
        result.includes("failed") ||
        result.includes("positive") ||
        result.includes("abnormal")
    );
  const isResultpassedchildlab =
    hasChildLabResults &&
    childLabResults.every(
      (result) =>
        result.includes("passed") ||
        result.includes("negative") ||
        result.includes("normal")
    );
      if(key===undefined){
    if (isResultpassedchildlab && key!='provider_signature' && key!='status' ) {
      returnResult.status = "Negative";
      returnResult.activity_status = "Ready for Revieww";
    }
    if (isResultfailedchildlab && key!='provider_signature' && key!='status') {
      returnResult.status = "Positive";
      returnResult.activity_status = "Ready for Review";
    }
  }
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
  const laborder = ['lab_id','lab_order_id','test_date','test_time'];

  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && laborder.includes(key)) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }
  if(key === 'provider_signature' && formData.status) {
    const normalizedStatus = String(formData.status || '').trim().toLowerCase();
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['normal', 'abnormal', 'negative', 'positive', 'dispensed', 'administered', 'failed', 'passed'];
    
    if (completionStatuses.includes(normalizedStatus)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Ready for Review';
    }
  }
  console.log("returnResult",returnResult);

  return returnResult;
}
const computationRules = (formData, key,visitType) => {
  let returnResult = {};
  // if((key==='status' || key==='provider_signature') && (formData.status==='Normal' || formData.status==='Abnormal') && (formData.provider_signature==='' || formData.provider_signature===null || formData.provider_signature===undefined)){
  //   return {
  //     activity_status: 'Pending Provider Review'
  //   };
  // }
  // if(key==='status' && formData.status==='Not Started' ){
  //   return {
  //     activity_status: 'Not Started'
  //   };
  // }
  // if(key==='status' && formData.status==='Pending Result' ){
  //   return {
  //     activity_status: 'In Progress'
  //   };
  // }
  // if(visitType==='WorkComp' && key==='status' && (formData.status==='Normal' || formData.status==='Abnormal') && ( formData.provider_signature!=="" && formData.provider_signature!==null && formData.provider_signature!==undefined)){
  //   return {
  //     activity_status: 'Completed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='status' && formData.status==='Normal' &&  formData.provider_signature!==""){
  //   return {
  //     activity_status: 'Passed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='status' && formData.status==='Abnormal' &&  formData.provider_signature!==""){
  //   return {
  //     activity_status: 'Failed'
  //   };
  // }
  // if(visitType==='WorkComp' && key==='provider_signature' && formData.provider_signature!=='' && (formData.status==='Normal' || formData.status==='Abnormal')){
  //   return {
  //     activity_status: 'Completed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='provider_signature' && formData.provider_signature!=='' && formData.status==='Normal'){
  //   return {
  //     activity_status: 'Passed'
  //   };
  // }
  // if(visitType!=='WorkComp' && key==='provider_signature' && formData.provider_signature!=='' && formData.status==='Abnormal'){
  //   return {
  //     activity_status: 'Failed'
  //   };
  // }
  // if (key === "status" || key === "activity_status") {
  //   return {};
  // }
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
 

  // If user changes any field while both status and activity_status are "Not Started",
  // move to Pending Result / In Progress
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if (key === 'lab_id') {
    returnResult['lab_order_id'] = '';
  }
  //  else if (key=='test_result') {
  //   const {status}=LabResultCalcualtion(formData['test_result']);
   
  //   if(status=='NEGATIVE'){
  //     returnResult['status']='PASSED';
  //   }else if(status=='POSITIVE'){
  //     returnResult['status']='FAILED';
  //   }else{
  //     returnResult['status']=status;
  //   }
    
  // }

  return returnResult;
}
